import type { LayoutSpec } from '../../../../types/LayoutConfig';
import { CARE_ORDERS_LAYOUT_ID, CARE_ORDERS_LAYOUT_TEMPLATE_ID } from '../tokens';
import { CARE_ORDERS_LAYOUT } from './CareOrders';

export const CARE_ORDERS_LAYOUT_SPEC: LayoutSpec = {
  templateId: CARE_ORDERS_LAYOUT_TEMPLATE_ID,
  label: 'Care Orders',
  id: CARE_ORDERS_LAYOUT_ID,
  dockViewLayout: CARE_ORDERS_LAYOUT,
  constraints: [],
  collapsablePanels: [],
};
